import React, { useEffect, useState } from "react";
import Card from "components/card";
import { Form, Input } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getFarmDetails, doFarmCreate, doFarmUpdate 
} from "../../../../../redux/farm/farmState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from '../../../../../utils/crudSagaHelper';
import RegionProvinceBarangay from "components/fields/RegionProvinceBarangay";
import { renderLabel } from "../../../../../utils/index";

const FarmForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, errors, regions, provinces, municipalities, barangays, ...props}) => {
	
  	const { recordId, accountId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord({accountId, recordId: recordId ?? 0});
	}, [recordId, getRecord, accountId]);
	
	useEffect(() => {
		if(recordData){
			
			const { address, ...restData } = recordData;
	        const initialValues = {
				account_id: accountId,
	            ...restData,
				...Object.fromEntries(
					Object.entries(address || {}).map(([key, value]) => [`address_${key}`, value])
				),	
	        };
			console.log(initialValues);
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (formData) => {	
    	try {  

			const selectedRegion = regions.find(region => region.code === formData.address_region_code);
			formData.address_region = selectedRegion.name;

			const selectedProvince = provinces.find(province => province.code === formData.address_province_code);
			formData.address_province = selectedProvince ? selectedProvince.name : '';

			const selectedMunicipality = municipalities.find(municipality => municipality.code === formData.address_municipality_code);
			formData.address_municipality = selectedMunicipality.name;

			const selectedBarangay = barangays.find(barangay => barangay.code === formData.address_barangay_code);
			formData.address_barangay = selectedBarangay.name;
			
			formData.id = recordId ?? 0;
			formData.account_id = parseInt(accountId);
			formData.id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="form"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>

				<div className="grid grid-cols-2">
					<FormItem 
						name="name"
						label="Farm Name"
						rules={[requiredField()]}
					>
						{mode === 'edit' ?
						<Input id="name"
							maxLength={50}		            		
							/> 
						: renderLabel(recordData?.name)
						}           
					</FormItem>        
				</div>	

				<label className="form-section-label">Farm Location</label>
				<div className="form-column-4">
					<FormItem extra="col-span-4"
						name="address_address_line1"
						label="Lot No./Street"
					>
						{mode === 'edit' ?
						<Input id="address_address_line1"
							maxLength={100}		            		
						/>
						: renderLabel(recordData?.address?.address_line1)
						}	                
					</FormItem>			
					<div className="col-span-4">
						<RegionProvinceBarangay recordData={recordData} mode={mode} form={form} rules={[requiredField()]}/>
					</div>
				</div>
				
	 			<CrudButtons baseRoute={`/console/accounts/${accountId}/farms`} mode={mode} recordId={recordId} /> 				 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.farm.details?.data,
  	requesting: state.farm.details?.requesting,
  	success: state.farm.details?.succcess,
	regions: state.psgcData.regions?.items,
	provinces: state.psgcData.provinces?.items,
	municipalities: state.psgcData.municipalities?.items,
	barangays: state.psgcData.barangays?.items,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmDetails(id)),
  	doCreate: (data) => dispatch(doFarmCreate(data)),
  	doUpdate: (data) => dispatch(doFarmUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmForm);
